<template>
  <div class="card__body-size" v-if="option" :style="{
    '--options': option.sizes.length,
    '--options-active': activeOptionIndex
  }">
    <div class="card__body-radio" v-for="(size, index) in option.sizes">
      <input @change="$emit('updateOption', option.product_option_id, size.product_option_value_id); activeOptionIndex = index + 1" :checked="isSizeSelected(size.product_option_value_id)" :id="'size' + size.product_option_value_id" type="radio" :name="'size' + product.product_id">
      <label :for="'size' + size.product_option_value_id">{{ size.name }}</label>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TheProductSizes',
  data() {
    return {
      option: null,
      activeOptionIndex: 1
    }
  },
  mounted() {
    this.option = this.product.options.find((option) => option.type === 'select');
  },
  props: {
    product: {
      type: Object,
      require: true,
    },
    options: {
      type: Object,
      require: true,
    }
  },
  methods: {
    isSizeSelected(product_option_value_id) {
      return this.options.some(option => Object.values(option).includes(product_option_value_id));
    },
  }
}
</script>

<style lang="scss" scoped>

</style>